
import { Pipe, PipeTransform } from '@angular/core';



@Pipe({ name: 'timediff' })
export class TimeDiffPipe implements PipeTransform {
    
    
    
    transform(concatval: string): string
     {
        var date2String:string = concatval.split('*')[0];
        var date1String:string = concatval.split('*')[1];
        
        let date1 = new Date(date1String);
        let date2 = new Date(date2String);
      
  
      var hourDiff = date2.getTime() - date1.getTime(); //in ms
      var secDiff = hourDiff / 1000; //in s
      var minDiff = hourDiff / 60 / 1000; //in minutes
      var hDiff = hourDiff / 3600 / 1000; //in hours
      //var humanReadable = {};
     var  humanReadableHour = Math.floor(hDiff);
     var  humanReadableMinutes = minDiff - 60 * humanReadableHour;


     let diffHrs = Math.floor((hourDiff % 86400000) / 3600000); // hours
     let diffMins = Math.round(((hourDiff % 86400000) % 3600000) / 60000); // minutes

   let outp:string= diffHrs + " hours, " + diffMins + " minutes";

      return outp;// humanReadableHour + ":" +  humanReadableMinutes  ;

     
    }
  }